/*
 * Venn Platform API 1.0.0 Operations for "admin"
 * Automatically generated file - do not modify!
 */

import type { ViewUpgradeResult } from '../types';
import type { OperationResult } from '../../utils';
import { buildQuery, buildRequestInit, extractError } from '../../utils';

/** Upgrade a view from V1 to V2. */
export async function upgradeViewVersion(
  id: string,
  override?: boolean,
  signal?: AbortSignal,
): Promise<OperationResult<ViewUpgradeResult>> {
  const endpoint = `/api/admin/analysis/upgrade/${encodeURIComponent(id)}${buildQuery({ override })}`;
  const requestInit = buildRequestInit({ method: 'PATCH', signal });
  const response = await fetch(endpoint, requestInit);
  if (response.status >= 200 && response.status < 400) {
    const content: ViewUpgradeResult = (await response.json()) as ViewUpgradeResult;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
/** Upgrade all views in a workspace from V1 to V2. */
export async function upgradeWorkspaceViews(
  workspaceId: number,
  excludeTemplates?: boolean,
  override?: boolean,
  excludeViews?: boolean,
  signal?: AbortSignal,
): Promise<OperationResult<null>> {
  const endpoint = `/api/admin/analysis/upgrade/workspace/${encodeURIComponent(workspaceId)}${buildQuery({ excludeTemplates, override, excludeViews })}`;
  const requestInit = buildRequestInit({ method: 'PATCH', signal });
  const response = await fetch(endpoint, requestInit);
  if (response.status >= 200 && response.status < 400) {
    const content = null;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
/** Upgrade all views in the environment from V1 to V2. */
export async function upgradeAllViews(
  excludeTemplates?: boolean,
  excludeViews?: boolean,
  excludeVennTemplates?: boolean,
  override?: boolean,
  startFrom?: number,
  signal?: AbortSignal,
): Promise<OperationResult<null>> {
  const endpoint = `/api/admin/analysis/upgrade/all${buildQuery({ excludeTemplates, excludeViews, excludeVennTemplates, override, startFrom })}`;
  const requestInit = buildRequestInit({ method: 'PATCH', signal });
  const response = await fetch(endpoint, requestInit);
  if (response.status >= 200 && response.status < 400) {
    const content = null;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
